import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // fallbackLng: "en",

    fallbackLng: {
      ar: ["ar"],
      default: ["en"],
    },

    // ns: ['ar', 'en'],
    // ns: ["factory"],
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: "/locales/{{lng}}//{{ns}}.json",
      // loadPath: "/locales/{{lng}}//{{ns}}/translation.json",
    },
  });

export default i18n;
